import React from "react";
import { GitCompare, X } from "lucide-react";
import { INTENT, visibleText } from "./ComposeCard";
import { cr, toolLabel } from "./sandboxUtil";

const fmt = (v) => (v === undefined ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));
const ROWS = [
  ["tool", "Tool dipilih", (r) => toolLabel(r.decision?.tool)],
  ["visible", "Yang dilihat pengguna", (r) => (r.compose ? visibleText(r.compose) : "—")],
  ["intent", "Maksud pesan", (r) => (r.compose?.intent ? INTENT[r.compose.intent] || r.compose.intent : "—")],
  ["sections", "Bagian dirujuk", (r) => (r.compose?.sections?.length ? r.compose.sections.join(", ") : "—")],
  ["clear", "Brief jelas", (r) => (r.compose?.clear === undefined ? "—" : r.compose.clear ? "ya" : "tidak")],
  ["picker", "Cara memilih hasil", (r) => r.compose?.picker || "—"],
  ["say", "Kalimat asisten", (r) => r.decision?.say || "—"],
  ["credits", "Kredit", (r) => cr(r.credits)],
];

export function paramDiff(saved = {}, draft = {}) {
  return [...new Set([...Object.keys(saved), ...Object.keys(draft)])].filter((k) => JSON.stringify(saved[k]) !== JSON.stringify(draft[k])).map((k) => [k, saved[k], draft[k]]);
}

export function CompareResult({ saved, draft, diff, onClose }) {
  const rows = ROWS.map(([k, l, f]) => [k, l, f(saved), f(draft)]).filter(([k, , a, b]) => k === "tool" || k === "visible" || a !== "—" || b !== "—");
  const changed = rows.filter(([k, , a, b]) => k !== "credits" && a !== b).length;
  return (
    <div className="aivora-card p-4" data-testid="sb-compare">
      <div className="mb-3 flex items-center gap-2"><GitCompare size={15} className="text-brand" /><p className="flex-1 text-sm font-bold text-slate-900">Bandingkan parameter</p>
        <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${changed ? "bg-amber-50 text-amber-700" : "bg-emerald-50 text-emerald-700"}`} data-testid="sb-compare-summary">{changed ? `${changed} perbedaan` : "Hasil sama"}</span>
        <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-700" aria-label="Tutup perbandingan" data-testid="sb-compare-close"><X size={14} /></button></div>
      <div className="mb-3 flex flex-wrap gap-1.5" data-testid="sb-compare-params">
        {diff.map(([k, a, b]) => <span key={k} className="rounded-full bg-slate-100 px-2 py-0.5 font-mono text-[10px] text-slate-600" data-testid={`sb-compare-param-${k}`}>{k}: <s className="text-slate-400">{fmt(a)}</s> → <b className="text-brand">{fmt(b)}</b></span>)}
      </div>
      <div className="overflow-x-auto"><table className="w-full min-w-[420px] text-xs">
        <thead className="text-left text-[10px] uppercase tracking-wider text-slate-500"><tr><th className="w-36 py-1.5" /><th className="py-1.5">Parameter tersimpan</th><th className="py-1.5">Draf</th></tr></thead>
        <tbody>
          {rows.map(([k, l, a, b]) => { const diffRow = k !== "credits" && a !== b; return (
            <tr key={k} className={`border-t border-line align-top ${diffRow ? "bg-amber-50/70" : ""}`} data-testid={`sb-compare-row-${k}`} data-diff={diffRow ? "1" : "0"}>
              <td className="py-1.5 pr-2 text-[11px] font-semibold text-slate-500">{l}</td>
              <td className="py-1.5 pr-2 text-slate-700" data-testid={`sb-compare-${k}-saved`}>{a}</td>
              <td className={`py-1.5 ${diffRow ? "font-bold text-slate-900" : "text-slate-700"}`} data-testid={`sb-compare-${k}-draft`}>{b}</td>
            </tr>); })}
        </tbody>
      </table></div>
      <p className="mt-2 text-[11px] text-slate-500">Kedua uji memakai teks & pesan yang sama; hanya parameter yang berbeda. Kredit terpakai: {cr((saved.credits || 0) + (draft.credits || 0))}.</p>
    </div>
  );
}
